<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('malfunctions')">Malfunctions</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
    </div>
    <trashed-message v-if="malfunctionData.deleted_at" class="mb-6" @restore="restore">
      This malfunction has been deleted.
    </trashed-message>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="full name" />
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
          <button v-if="!malfunctionData.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Malfunction</button>
          <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">Update Malfunction</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  props: {
    errors: Object,
    malfunctionData: Object,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        name: this.malfunctionData.name,
        id: this.malfunctionData.id,
      },
    }
  },
  methods: {
    submit() {
      var data = new FormData()
      data.append('name', this.form.name || '')
      data.append('_method', 'put')

      this.$inertia.post(this.route('malfunctions.update', this.malfunctionData.id), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {

          }
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Malfunction?')) {
        this.$inertia.delete(this.route('malfunctions.destroy', this.malfunctionData.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Malfunction?')) {
        this.$inertia.put(this.route('malfunctions.restore', this.malfunctionData.id))
      }
    },
  },
}
</script>
